<template>
    <div class="placeholder" role="alert">
        <IconAlertCircle class="placeholder__icon" />
        <p class="h3">{{ title }}</p>
        <p v-if="detail">{{ detail }}</p>
        <button v-if="retry" type="button" class="btn" @click="retry()">Try Again</button>
    </div>
</template>

<script lang="ts">
import { IconAlertCircle } from '@tabler/icons-vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SomethingWentWrong',

    components: {
        IconAlertCircle,
    },

    props: {
        title: {
            type: String,
            default: 'Something Went Wrong',
        },
        detail: {
            type: String,
            default: 'This content could not be loaded.',
        },
        retry: Function,
    },
});
</script>
